/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AddUpdateOrderYieldModal_orderYield$ref: FragmentReference;
declare export opaque type AddUpdateOrderYieldModal_orderYield$fragmentType: AddUpdateOrderYieldModal_orderYield$ref;
export type AddUpdateOrderYieldModal_orderYield = {|
  +id: string,
  +order: {|
    +id: string
  |},
  +orderedQuantity: number,
  +unitPrice: ?number,
  +item: {|
    +id: string,
    +name: string,
    +quantityUOM: {|
      +id: string,
      +name: string,
      +symbol: string,
    |},
  |},
  +$refType: AddUpdateOrderYieldModal_orderYield$ref,
|};
export type AddUpdateOrderYieldModal_orderYield$data = AddUpdateOrderYieldModal_orderYield;
export type AddUpdateOrderYieldModal_orderYield$key = {
  +$data?: AddUpdateOrderYieldModal_orderYield$data,
  +$fragmentRefs: AddUpdateOrderYieldModal_orderYield$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "AddUpdateOrderYieldModal_orderYield",
  "type": "OrderYield",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "order",
      "storageKey": null,
      "args": null,
      "concreteType": "Order",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "orderedQuantity",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "unitPrice",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "item",
      "storageKey": null,
      "args": null,
      "concreteType": "Item",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "quantityUOM",
          "storageKey": null,
          "args": null,
          "concreteType": "UOM",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "symbol",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '38b47fc7c7df30d9cf67e44b04c761b0';
module.exports = node;
